export const FLIGHTS_FORM = 'flight_form';
export const HOTEL_FORM = 'hotel_form';
